import React, { Fragment, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HeaderBar from "./components/HeaderBar/HeaderBar";
import IntroPicture from "./components/IntroPicture/IntroPicture";
import MainGrid from "./components/MainGrid/MainGrid";
import DisplayPost from "./components/DisplayPost/DisplayPost";
import ScreenHeightWidthTester from "./components/devTools/ScreenHeightWidthTester";
import "./App.css";
import FootBar from "./components/UI/FootBar";

export class AppHelper {
  static storageUrl = "../contentstorage/";
  static downloadUrl = "s3.eu-west-3.amazonaws.com/federowi.cz/downloads/";
  static ReturnLanguageContent(contentObject, LanguageContext) {
    if (LanguageContext === "pl") {
      return contentObject.pl;
    } else {
      return contentObject.en;
    }
  }
}

export const LanguageContext = React.createContext();

function App() {
  const [selectedLanguage, setSelectedLanguage] = useState(`pl`);

  function toggleLanguage() {
    if (selectedLanguage === `pl`) {
      setSelectedLanguage(`en`);
    } else {
      setSelectedLanguage(`pl`);
    }
  }

  return (
    <Fragment>
      <LanguageContext.Provider value={selectedLanguage}>
        <Router>
          <HeaderBar toggleLanguage={toggleLanguage} />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <MainGrid />
                </>
              }
            />
            <Route path="/:id" element={<DisplayPost />} />
          </Routes>
          <FootBar />
        </Router>
      </LanguageContext.Provider>
      {/* <ScreenHeightWidthTester></ScreenHeightWidthTester> */}
    </Fragment>
  );
}

export default App;
